import { useEffect } from "react";
import { useDispatch } from "react-redux";

import useLocationQueryParams from "./useLocationQueryParams";
import { setSelectedDepot } from "../store/actions/app";

const useDepotChangeListener = () => {
  const { depot } = useLocationQueryParams();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setSelectedDepot(depot));
  }, [depot, dispatch]);
};

export default useDepotChangeListener;
